import { evalCondition, regexEmail } from 'mailup-react-helpers'
import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'

import {
  FormElement,
  INPUT_TEXT_VARIANT_DANGER,
  InputText
} from 'mailup-web-components'

import { abTestState } from 'Pages/AbTestWizard/recoil/state/abtest'

const InputSenderReplyTo = () => {
  const intl = useIntl()
  const [{ step2 }, setAbTestState] = useRecoilState(abTestState)

  const handleChangeReplyTo = e => {
    setAbTestState(prev => ({
      ...prev,
      step2: {
        ...prev.step2,
        step2IsDirty: true,
        senderInfo: {
          ...prev.step2.senderInfo,
          replyToEmail: e.target.value,
          replyToEmailIsDirty: true
        }
      }
    }))
    if (e.target.value.match(regexEmail)) {
      setAbTestState(prev => ({
        ...prev,
        step2: {
          ...prev.step2,
          step2IsDirty: true,
          senderInfo: {
            ...prev.step2.senderInfo,
            invalidReplyTo: false
          }
        }
      }))
    } else {
      setAbTestState(prev => ({
        ...prev,
        step2: {
          ...prev.step2,
          step2IsDirty: true,
          senderInfo: {
            ...prev.step2.senderInfo,
            invalidReplyTo: true
          }
        }
      }))
    }
  }

  return (
    <div>
      {step2.senderInfo.isPEC ? (
        <>
          <FormElement
            required
            label={intl.formatMessage({ id: 'Load.Common.ReplyToEmailLabel' })}
            labelHelp={intl.formatMessage({
              id: 'Load.PecPlus.replyToPecTooltip'
            })}
          >
            <InputText placeholder={step2.senderInfo.replyToEmail} disabled />
          </FormElement>
        </>
      ) : (
        <>
          <FormElement
            required
            label={intl.formatMessage({ id: 'Load.Common.ReplyToEmailLabel' })}
            feedback={
              step2.senderInfo.replyToEmail === ''
                ? intl.formatMessage({
                    id: 'Load.EmailSendingWizard.SenderNameRequired'
                  })
                : step2.senderInfo.replyToEmail !== '' &&
                  step2.senderInfo.invalidReplyTo
                ? intl.formatMessage({ id: 'Load.Common.WrongFormatWarning' })
                : undefined
            }
          >
            <InputText
              data-mu-test='abtest-wizard-input-reply-to-email'
              value={step2.senderInfo.replyToEmail}
              disabled={evalCondition('uo:EMAILSENDERLOCKED')}
              onChange={handleChangeReplyTo}
              variant={
                step2.senderInfo.replyToEmail === '' ||
                step2.senderInfo.invalidReplyTo
                  ? INPUT_TEXT_VARIANT_DANGER
                  : null
              }
            />
          </FormElement>
        </>
      )}
    </div>
  )
}

export default InputSenderReplyTo
